import { render, staticRenderFns } from "./ProductAdditionalOptionValue.vue?vue&type=template&id=8a4e7ec0"
import script from "./ProductAdditionalOptionValue.vue?vue&type=script&lang=js"
export * from "./ProductAdditionalOptionValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports